import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/medal-point-pink.svg'
import _imports_1 from '@/assets/images/medal.svg'
import _imports_2 from '@/assets/images/medal-point-gray.svg'


const _withScopeId = n => (_pushScopeId("data-v-0f6206dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-75 px-lg-5 mt-lg-5 mt-4 break-word" }
const _hoisted_2 = { class: "fs-75 px-lg-5 break-word" }
const _hoisted_3 = { class: "fs-75 px-lg-5 break-word" }
const _hoisted_4 = { class: "fs-75 px-lg-5 mb-lg-5 mb-4 break-word" }
const _hoisted_5 = { class: "container bg-white shadow rounded-4 p-lg-5 px-2 py-4" }
const _hoisted_6 = { class: "text-center border-bottom-gold mb-2" }
const _hoisted_7 = { class: "d-lg-block d-none" }
const _hoisted_8 = { class: "font-weight" }
const _hoisted_9 = { class: "text-name fw-bold" }
const _hoisted_10 = { class: "font-weight" }
const _hoisted_11 = { class: "fw-bold d-lg-none" }
const _hoisted_12 = { class: "fs-7" }
const _hoisted_13 = { class: "fs-7" }
const _hoisted_14 = { class: "text-name fw-bold" }
const _hoisted_15 = { class: "d-flex flex-wrap mb-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-medal rounded-2 text-center ms-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "medal"
  })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "d-flex total-sub mx-lg-2 mx-4 justify-content-between" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-medal-small rounded-2 text-center mb-3 mb-lg-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "medal"
  })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-medal-small-gray rounded-2 text-center mb-3 mb-lg-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "medal"
  })
], -1))
const _hoisted_22 = [
  _hoisted_21
]

import { translate } from '@/languages/i18n'
import { numberWithCommas } from '@/constants/common.ts'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(translate)('SJ10messageTab2')), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(translate)('SJ10title2Tab2')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(translate)('SJ10title3Tab2')), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('SJ10title4Tab2')), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(translate)('SJ10inviteAlumni')) + "：", 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(numberWithCommas)(__props.data?.alumnus?.invited_count)), 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(translate)('name')), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(translate)('SJ10inviteAlumni')), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(__props.data?.alumnus?.invited_count), 1),
            _createTextVNode(" " + _toDisplayString(_unref(translate)('name')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.floor(__props.data?.alumnus?.invited_count / 10), (item) => {
          return (_openBlock(), _createElementBlock("div", { key: item }, _hoisted_17))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data?.alumnus?.invited_count % 10, (item) => {
          return (_openBlock(), _createElementBlock("div", { key: item }, _hoisted_20))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(9 - (__props.data?.alumnus?.invited_count % 10), (item) => {
          return (_openBlock(), _createElementBlock("div", { key: item }, _hoisted_22))
        }), 128))
      ])
    ])
  ], 64))
}
}

})